// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2Aaup","colCheckbox":"styles_colCheckbox__2PMD_"};